import {action, computed, makeObservable, observable, runInAction} from "mobx";
import CommonStore from "../../stores/CommonStore";
import { MoneyDeliveryService } from "../../service/productOrder/MoneyDeliveryService";
import MoneyDeliveryOrderResponse from "../../model/productOrder/moneyDelivery/MoneyDeliveryOrderResponse";
import UserStore from "../../stores/UserStore";
import Currency from "../../entities/Currency";
import Geo from "../../entities/Geo";
import Pagination from "../../entities/Pagination";

class MoneyDeliveryStore {

    public moneyRemittances: MoneyDeliveryOrderResponse[];
    public pagination: Pagination;
    public selectedMoneyRemittanceIds: string[];

    public filter?: string;
    public fromFilter: number | undefined;
    public toFilter: number | undefined;
    public currencyFilter?: Currency;
    public typeFilter?: string;
    public geoFilter?: Geo[];

    public commonStore: CommonStore;
    public userStore: UserStore;

    constructor(commonStore: CommonStore, userStore: UserStore) {
        this.pagination = new Pagination(1, 20, 0, 0);
        this.moneyRemittances = [];
        this.selectedMoneyRemittanceIds = [];
        this.commonStore = commonStore;
        this.userStore = userStore;
        makeObservable(this, {
            selectedMoneyRemittanceIds: observable,
            moneyRemittances: observable,
            isEmpty: computed
        });
        
    }

    get isEmpty(): boolean {
        return this.moneyRemittances.length === 0;
    }

    public setFilter(filter: string) {
        this.filter = filter;
    }

    public setFromFilter(from?: number) {
        this.fromFilter = from;
    }

    public setToFilter(to?: number) {
        this.toFilter = to;
    }

    public setCurrencyFilter(newCurrency: Currency) {
        this.currencyFilter = newCurrency;
    }

    public setTypeFilter(newType: string) {
        this.typeFilter = newType;
    }

    public setGeoFilter(newGeo: Geo[]) {
        this.geoFilter = newGeo;
    }

    @action
    public async clearFilter() {
        this.typeFilter = undefined;
        this.currencyFilter = undefined;
        this.geoFilter = undefined;
        this.fromFilter = undefined;
        this.toFilter = undefined;
        this.filter = undefined;
        await this.getElements();
    }

    @action
    public async search() {
        await this.getElements();
    }

    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.getElements(page, pageSize);
    }

    @action
    public async getElements(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.commonStore.setLoading();
        const response = await MoneyDeliveryService.get(
            page,
            pageSize,
            this.fromFilter,
            this.toFilter,
            this.userStore.currentUser()?.id,
            this.filter,
            this.currencyFilter,
            this.typeFilter,
            this.geoFilter && this.geoFilter.length > 0 ? this.geoFilter.map(t => t.id) : undefined,
        );
        runInAction(() => {
            this.moneyRemittances = response.data ? response.data.data : [];
            this.pagination = response.data?.pagination || this.pagination;
        })
        this.commonStore.removeLoading();
    }

}

export default MoneyDeliveryStore;